import { render, staticRenderFns } from "./FlippingCard.vue?vue&type=template&id=3151e32a&"
import script from "./FlippingCard.vue?vue&type=script&lang=js&"
export * from "./FlippingCard.vue?vue&type=script&lang=js&"
import style0 from "./FlippingCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports